import { render, staticRenderFns } from "./Trusted-customers.vue?vue&type=template&id=a8e22dac&scoped=true"
import script from "./Trusted-customers.vue?vue&type=script&lang=js"
export * from "./Trusted-customers.vue?vue&type=script&lang=js"
import style0 from "./Trusted-customers.vue?vue&type=style&index=0&id=a8e22dac&prod&scoped=true&lang=css"
import style1 from "./Trusted-customers.vue?vue&type=style&index=1&id=a8e22dac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8e22dac",
  null
  
)

export default component.exports